import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ConfirmModalHeader.module.css';
export type ConfirmModalHeaderProps = ComponentProps<'div'>;
export const ConfirmModalHeader: FunctionComponent<ConfirmModalHeaderProps> = React.memo(props => {
  const $ = _c(8);
  let children;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      children: t2,
      className,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t2;
    t0 = remainingProps;
    t1 = classes(className, styles.header);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t0 || $[6] !== t1) {
    t2 = <div {...t0} className={t1}>{children}</div>;
    $[4] = children;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
});